import capitalize from 'lodash.capitalize';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import TextInput from '@/components/UI/TextInput';
import { MAXIMUM_TEAM_TITLE_LENGTH } from '@/utils/constants';
import singularize from '@/utils/singularize';
import type { EntityListValues } from './EntityList.types';
export default (function EntityListTitle({
  name,
  index,
}: {
  name: string;
  index: number;
}) {
  const { control, setValue } = useFormContext<EntityListValues>();
  const title = useWatch<EntityListValues>({
    name: `${name}.${index}.title`,
  });
  return (
    <Controller
      render={({ field }) => {
        return (
          <TextInput
            flex
            maxLength={name === 'teams' ? MAXIMUM_TEAM_TITLE_LENGTH : undefined}
            variant="plain"
            placeholder={`${capitalize(singularize(name))} Slot ${index + 1}`}
            value={field.value || ''}
            onChangeText={(value) => {
              setValue(`${name}.${index}.title`, value, {
                shouldValidate:
                  (!value.length && !!title.length) ||
                  (!!value.length && !title.length),
                shouldDirty: true,
              });
            }}
            enterKeyHint="done"
            autoCapitalize="words"
            testID="EntityListTitle"
          />
        );
      }}
      name={`${name}.${index}.title`}
      control={control}
    />
  );
});
